import React from "react";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { copy, currentLang } from "../../shared/seo/links";
import { lawyerAddress, lawyerState } from "./lawyerHelpers";
import "./lawyers.css";

export default function LawyerProfileDescription(props) {
  const Lng = currentLang();
  const { t } = useTranslation();
  const lawyer = props.lawyer;
  const education = lawyer.Education || [];
  const services = lawyer.Services || [];
  // Address + governorate geocodes much better than the address alone.
  const mapQuery = [lawyerAddress(lawyer, "fr"), lawyerState(lawyer, "fr"), "Tunisie"]
    .filter(Boolean)
    .join(", ");

  return (
    <>
      <section className="avc-profile-section">
        <h2 className="avc-profile-section__title">{t("About_Me")}</h2>
        {copy.stripHtml(lawyer.aboutMe) ? (
          <div
            className="avc-profile-section__text"
            dangerouslySetInnerHTML={{ __html: lawyer.aboutMe }}
          />
        ) : (
          // Same generated text the server renders for this profile.
          <p className="avc-profile-section__text">{copy.lawyer(Lng, lawyer).about}</p>
        )}
      </section>

      {services.length !== 0 && (
        <section className="avc-profile-section">
          <h2 className="avc-profile-section__title">{t("Services")}</h2>
          <ul className="avc-services">
            {services.map((item, i) => (
              <li key={item._id || i} className="avc-services__item">
                <i className="fas fa-gavel" aria-hidden="true"></i>
                <div>
                  <h3>{item.title}</h3>
                  {item.description && <p>{item.description}</p>}
                </div>
              </li>
            ))}
          </ul>
        </section>
      )}

      {education.length !== 0 && (
        <section className="avc-profile-section">
          <h2 className="avc-profile-section__title">{t("Education")}</h2>
          <ol className="avc-timeline">
            {education.map((item, i) => (
              <li key={item._id || i} className="avc-timeline__item">
                <span className="avc-timeline__years" dir="ltr">
                  {item.startedAt ? moment(item.startedAt).format("YYYY") : ""}
                  {item.endedAt ? " – " + moment(item.endedAt).format("YYYY") : ""}
                </span>
                <h3>{item.title}</h3>
                {item.description && <p>{item.description}</p>}
              </li>
            ))}
          </ol>
        </section>
      )}

      <section className="avc-profile-section">
        <h2 className="avc-profile-section__title">{t("Maps")}</h2>
        <div className="avc-map">
          <iframe
            title={t("Maps")}
            loading="lazy"
            src={
              "https://www.google.com/maps?q=" +
              encodeURIComponent(mapQuery) +
              "&output=embed"
            }
          ></iframe>
        </div>
        <a
          className="avc-map__link"
          href={
            "https://www.google.com/maps/search/?api=1&query=" +
            encodeURIComponent(mapQuery)
          }
          target="_blank"
          rel="noopener noreferrer"
        >
          <i className="fas fa-external-link-alt" aria-hidden="true"></i>
          {t("profile_open_map")}
        </a>
      </section>
    </>
  );
}
